import { render, staticRenderFns } from "./TripTypesFormInput.vue?vue&type=template&id=b9f18252&scoped=true&"
import script from "./TripTypesFormInput.vue?vue&type=script&lang=js&"
export * from "./TripTypesFormInput.vue?vue&type=script&lang=js&"
import style0 from "./TripTypesFormInput.vue?vue&type=style&index=0&id=b9f18252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f18252",
  null
  
)

/* custom blocks */
import block0 from "./TripTypesFormInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports